import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const internalTxnViewAll = createAsyncThunk(
  "internalTxnViewAll",
  async (values) => {
    const {
      page_no,
      page_item_count,
      amount,
      min_amount,
      max_amount,
      lifecycle_status,
      payment_method,
      internal_account_id,
      owner_account_id,
      start_date,
      end_date,
      txn_id,
      entity_id,
      category,
      bank_identifier,
      distribution_lifecycle_status,
      additional_data,
      confidential_transaction,
      category_value,
      category_name,
      refactor,
      labels,
    } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/internal`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: page_no,
            page_size: page_item_count,
            amount: amount,
            min_amount: min_amount,
            max_amount: max_amount,
            lifecycle_status: lifecycle_status,
            payment_method: payment_method,
            internal_account_id: internal_account_id,
            owner_account_id: owner_account_id,
            start_date: start_date,
            end_date: end_date,
            txn_id: txn_id,
            entity_id: entity_id,
            category: category,
            bank_identifier: bank_identifier,
            distribution_lifecycle_status: distribution_lifecycle_status,
            additional_data: additional_data,
            confidential_transaction:
              confidential_transaction === "Show only confidential"
                ? "Y"
                : confidential_transaction === "Hide confidential"
                  ? "N"
                  : undefined,
            category_name: category_name,
            category_value: category_value,
            refactor: refactor,
            labels: labels,
          },
        },
      );
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  },
);

const internalTxnViewAllDataSlice = createSlice({
  name: "internalTxnViewAllData",
  initialState: {
    storedPage: 1,
    toggle: false,
    internalTxnAvailableLabels: [],

    InternalTxnAvailableLabels: [],

    internalTxnViewAllAccData: null,
    internalTxnViewAllAccLoading: false,
    internalTxnViewAllAccError: null,
  },
  reducers: {
    setToggle: (state, action) => {
      state.toggle = action.payload;
    },
    setAvailabelLabels: (state, action) => {
      state.InternalTxnAvailableLabels = action.payload;
    },
    resetToggle: (state) => {
      state.toggle = false;
    },
    resetInternalTxnViewAll: (state) => {
      state.internalTxnViewAllAccData = null;
      state.internalTxnViewAllAccLoading = false;
      state.internalTxnViewAllAccError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(internalTxnViewAll.fulfilled, (state, action) => {
      state.InternalTxnAvailableLabels =
        action?.payload?.summary?.available_labels;

      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabelsInternalTxn",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
      state.internalTxnViewAllAccLoading = false;
      state.internalTxnViewAllAccData = action.payload;
      state.internalTxnAvailableLabels =
        action?.payload?.summary?.available_labels;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabelsInternalTxn",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
    });
    builder.addCase(internalTxnViewAll.rejected, (state, action) => {
      if (action?.payload?.summary?.available_labels) {
        state.InternalTxnAvailableLabels = [];
      }
      state.internalTxnViewAllAccError = true;
      state.internalTxnViewAllAccData = null;
      state.internalTxnViewAllAccLoading = false;
    });
    builder.addCase(internalTxnViewAll.pending, (state, action) => {
      if (action?.payload?.summary?.available_labels) {
        state.InternalTxnAvailableLabels = [];
      }
      state.internalTxnViewAllAccLoading = true;
    });
  },
});

export const {
  setToggle,
  resetpage,
  setStoredPage,
  resetToggle,
  resetInternalTxnViewAll,
} = internalTxnViewAllDataSlice.actions;

export default internalTxnViewAllDataSlice.reducer;
